import React from 'react'
import { useState } from "react";
import axios from 'axios'
import { config } from '../../../config';
import AuthContext from '../../../contexts/AuthContext';
import DocumentAnalysisContext from '../../../contexts/DocumentAnalysisContext';

import './mytestpage.css'
import { PushButton } from '../pushbutton/PushButton'


export const MyTestPage = () => {

  const [status, setStatus] = useState('')
  const [statusText, setStatusText] = useState('')
  
  let text = 'Grass is blue. Sky is red. Car is green. Sun is pink.'

  const {
    currentUser,
    checkServerCode, 
} = React.useContext(AuthContext);

  const {
    textvectorization,
    setTextVectorization, 
} = React.useContext(DocumentAnalysisContext);

const handleKeywordsVectorization = () => {
  let vectorizationMode = localStorage.getItem('vectorizationMode') || 'true';

  // Convert to boolean properly
  const boolValue = vectorizationMode === 'true';
  const toggled = !boolValue;

   localStorage.setItem('vectorizationMode', String(toggled));
  console.log("After:", localStorage.getItem('vectorizationMode'))

  setTextVectorization(toggled); // use consistent boolean value
};

const handleOnTest = async () => {
    console.log("handleOnTest")
      try{
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/mytestpage/testpython", {currentUser, text},{
                    withCredentials:true
          })
          //console.log('Res:', res)
          setStatus(res.data.message + ': ' + res.data.pythonResult)
          setStatusText(res.data.text)
          
      }
      catch (err) {
          setStatus(`Error: ${checkServerCode(err.code)}`)
          return;
      }
  }

  const handleTestMyBookPython = async () => {
    console.log("handleTestMyBookPython")
    handleClearStatus()
      try{
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/mytestpage/testmybookpython", {currentUser},{
                    withCredentials:true
          })
          //console.log('Res:', res)
          setStatus(res.data.message + ': ' + res.data.result)
          //setStatusText(res.data.text)
          
      }
      catch (err) {
          setStatus(`Error: ${checkServerCode(err.code)}`)
          return;
      }
  }

  const handleTestMyBookNodeJS = async () => {
    console.log("handleTestMyBook - NodeJS")
    handleClearStatus()
      try{
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/mytestpage/testmybooknodejs", {currentUser},{
                    withCredentials:true
          })
        
          setStatus(res.data.message + ': ' + res.data.result)
        
          
      }
      catch (err) {
          setStatus(`Error: ${checkServerCode(err.code)}`)
          return;
      }
  }

  const handleEmbedings = async () => {
    console.log("handleEmbeding - NodeJS")
    handleClearStatus()
      try{
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/mytestpage/testembedings", {currentUser},{
                    withCredentials:true
          })
         
          setStatus(res.data.message + '\nVector:' + res.data.result)
       
          
      }
      catch (err) {
          setStatus(`Error: ${checkServerCode(err.code)}`)
          return;
      }
  }

  const handleLoadPDFandEmbedded = async () => {
    console.log("handleLoadPDF")
    handleClearStatus()
      try{
          const res = await axios.post(config.url.API_URL + "/deda_ai_api/mytestpage/loadpdf", {currentUser},{
                    withCredentials:true
          })
      
          //setStatus(res.data.message + ': ' + res.data.result)
          setStatus(res.data.message + 
            '\nPages:' + res.data.pages + 
            '\nChunks:' + res.data.chunks + 
            '\nAnswer:' + res.data.query + 
            '\nTokens:' + res.data.tokens) 
          
      }
      catch (err) {
          setStatus(`Error: ${checkServerCode(err.code)} +
              \nReason: ${err.message}`)
          return;
      }
  }



  const handleClearStatus = () => {
    setStatus('')
    setStatusText('')
  }

  return (
    <div className="homeContainer">
      <label>TEXT:</label>
      <br></br>
      <label style= {{color:'maroon'}}>{text}</label>
      <br></br>

        <PushButton onClick={handleKeywordsVectorization} label = {`${textvectorization ? 'Text vectorization' : 'Keywords vectorization'}`}/>
        <br></br>

        <PushButton onClick={handleOnTest} label = 'Test Python'/>
        <br></br>
      
        <PushButton onClick={handleTestMyBookPython} label = 'Test My Book - Python'/>
        <br></br>
       
        <PushButton onClick={handleTestMyBookNodeJS} label = 'Test My Book - NodeJS'/>
        <br></br>
      
        <PushButton onClick={handleEmbedings} label = 'Embedings'/>
        <br></br>
       
        <PushButton onClick={handleLoadPDFandEmbedded} label = 'Load PDF and Embedd'/>
        <br></br>
       
        <PushButton onClick={handleClearStatus} label = 'Clear Status'/>
        <br></br>

      <div style={{ whiteSpace: 'pre-line' }}> {status}</div>
      <br></br>
      <label> {statusText}</label>
    </div>
  )
}

export default MyTestPage